import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/curated-lists")({
  // Component moved to $orgSlug.admin.curated-lists.lazy.tsx for code splitting
});
